import { render, staticRenderFns } from "./LmButton.vue?vue&type=template&id=c2712a56&scoped=true"
import script from "./LmButton.vue?vue&type=script&lang=js"
export * from "./LmButton.vue?vue&type=script&lang=js"
import style0 from "./LmButton.vue?vue&type=style&index=0&id=c2712a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2712a56",
  null
  
)

export default component.exports